<template>
  <div class="content">
    <div class="chat-wrap">
      <div class="chat-content">
        <div class="chat-message-list" ref="messageList" v-scroll-loading="scrollTop">
          <div class="chat-message-list-tip">
            <slot name="chat-message-list-tip">没有更多消息了</slot>
          </div>
          <slot name="chat-message-list"></slot>
          <slot name="chat-message-follow-up"></slot>
        </div>
        <slot name="chat-message-input"></slot>
      </div>
    </div>
    <show-chat-info />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ShowChatInfo from './ShowChatInfo'
export default {
  name: 'ChatLayout',
  components: { ShowChatInfo },
  computed: {
    ...mapState({
      imMessages: state => state.imMessages,
      activeAccount: state => state.imActiveAccount,
      imMsgListToTop: state => state.imMsgListToTop,
      imMsgListToBottom: state => state.imMsgListToBottom
    })
  },
  watch: {
    imMsgListToBottom (val) {
      if (val) {
        this.scrollToBottom()
      }
    },
    imMsgListToTop (val) {
      if (val) {
        this.scrollToTop()
      }
    }
  },
  methods: {
    ...mapActions(['loadMoreMsgOfSession']),
    scrollToBottom () {
      this.$nextTick(() => {
        const messageList = this.$refs.messageList
        messageList.scrollTop = messageList.scrollHeight
      })
      this.$store.commit('imMsgListToBottomMutation', false)
    },
    scrollToTop () {
      this.$nextTick(() => {
        const messageList = this.$refs.messageList
        messageList.scrollTop = this.imMsgListToTop
        this.$store.commit('imMsgListToTopMutation', false)
      })
    },
    scrollTop () {
      if (this.activeAccount.id === '7380252502656237619') return
      let sTop = this.$refs.messageList.scrollTop
      if (sTop === 0) {
        this.loadMoreMsgOfSession({ scene: this.activeAccount.scene, to: this.activeAccount.to, limit: 10, messageListScrollTot: 'top' })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .content {
    position: relative;
    flex: 1;
    overflow: hidden;
    user-select: text;
  }
  .chat-wrap {
    height: 100%;
    width: 100%;
    display: flex;
  }
  .chat-content {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
  }
  .chat-message-list {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
  }
  .chat-message-list-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/common/im/right/chat/ChatLayout.vue